import { render, staticRenderFns } from "./ChaptersTable.vue?vue&type=template&id=6b2766cd&"
import script from "./ChaptersTable.vue?vue&type=script&lang=js&"
export * from "./ChaptersTable.vue?vue&type=script&lang=js&"
import style0 from "./ChaptersTable.vue?vue&type=style&index=0&id=6b2766cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports